import { BARCLAYS_SAVE_DATA } from "../../actions/barclays/types";

export const BarclaysData = (state = {}, action) => {
  switch (action.type) {
    case BARCLAYS_SAVE_DATA: {
      const { data } = action;
      return data;
    }
    default:
      return state;
  }
};
